import { get, post } from "./index";

// 定义接口返回的数据类型
interface SignMsgResponse {
  msg: string;
}
interface SignParams {
  msg: any;
  sign: any;
}
interface SignMsgParams {
  address: string;
}

// 钱包相关接口
export const authApi = {
  // 获取签名信息
  getSignMsg(data: SignMsgParams) {
    return get<SignMsgResponse>(`/login/sign/msg`, data);
  },

  // 修改方法名从 loginSign 到 setSign，以匹配 Header.vue 中的使用
  setSignApi(data: SignParams) {
    return post<{
      code: number;
      data: any;
      message: string;
    }>("/login/sign", data);
  },
};
